import {Locale} from '@aboutyou/config';
import {assertUnreachable} from '@aboutyou/utils';

export interface TopCategoryIds {
  female: number;
  male: number;
  children: number;
}

export function getTopCategoryIdsByLocale_UNSAFE(
  locale: Locale,
): TopCategoryIds {
  if (Object.values(Locale).includes(locale)) {
    return {
      male: 20202,
      female: 20201,
      children: 138113,
    };
  } else {
    assertUnreachable(locale as never);
  }
}
